import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-approve-button-renderer',
  template: `
    <button 
      *ngIf="shouldShowButton()"
      class="btn btn-primary btn-sm" 
      (click)="onApprove()">
      Aprobar
    </button>
    <span *ngIf="!shouldShowButton() && isApproved()" class="text-success">
      <i class="fas fa-check"></i>
    </span>
  `,
  styles: [`
    .btn-sm {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
    }
    .text-success {
      color: #28a745;
    }
  `]
})
export class ApproveButtonRendererComponent implements ICellRendererAngularComp {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  shouldShowButton(): boolean {
    return this.params.showButton && this.params.showButton(this.params.data);
  }

  isApproved(): boolean {
    const data = this.params.data;
    if (!data) return false;
    
    const field = this.params.column.getColId();
    return data[field] === true;
  }

  onApprove(): void {
    if (this.params.onApprove) {
      this.params.onApprove(this.params.data);
    }
  }

  refresh(): boolean {
    return true;
  }
} 